import GastoDetail from "./GastoDetail";
export default GastoDetail;